<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i
              class="fa-solid fa-users"
              aria-hidden="true"
            ></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ "Users" | transloco }}
            </span>

            <h2>
              {{ "Manage system users" | transloco }}
            </h2>

            <p *ngIf="totalUsers > 0">
              {{ "Showing" | transloco }}
              {{ allData.length }}
              {{ "of" | transloco }}
              {{ totalUsers }}
            </p>
          </div>

        </div>

        <div
          class="bbm-hero-counter"
          *ngIf="totalUsers > 0"
        >
          <strong>
            {{ totalUsers }}
          </strong>

          <span>
            {{ "Users" | transloco }}
          </span>
        </div>

      </div>

      <!-- ADD USER -->
      <div class="bbm-actions-grid bbm-hero-actions noPrint">

        <button
          type="button"
          routerLink="/Resigter"
          class="
            bbm-action-btn
            bbm-action-success
            bbm-action-wide
          "
        >
          <i
            class="fa-solid fa-user-plus"
            aria-hidden="true"
          ></i>

          <span>
            {{ "Users" | transloco }}
          </span>
        </button>

      </div>

    </section>

    <!-- FILTERS -->
    <section class="bbm-form-ticket">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ "Users" | transloco }}
          </span>

          <h3>
            {{ "Manage system users" | transloco }}
          </h3>
        </div>
      </div>

      <div class="bbm-form-grid">

        <!-- WAREHOUSE -->
        <div
          class="bbm-field bbm-field-wide"
          *ngIf="allWareHouses.length > 0"
        >
          <label>
            {{ "Current warehouse" | transloco }}
          </label>

          <div class="dropdown bbm-ticket-menu">

            <button
              type="button"
              class="
                bbm-action-btn
                bbm-action-primary
                bbm-action-wide
                dropdown-toggle
              "
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                class="fa-solid fa-store"
                aria-hidden="true"
              ></i>

              <span>
                {{
                  getSelectedWarehouseName() ||
                  ("Pospage" | transloco)
                }}
              </span>

              <i
                class="fa-solid fa-chevron-down"
                aria-hidden="true"
              ></i>
            </button>

            <ul class="dropdown-menu w-100">

              <li *ngFor="let el of allWareHouses">
                <a
                  class="dropdown-item"
                  [class.active]="el.id == warehouseId"
                  (click)="applyWareHouse(el.id)"
                >
                  <i
                    class="fa-solid fa-warehouse"
                    aria-hidden="true"
                  ></i>

                  <span>
                    {{ el.name }}
                  </span>
                </a>
              </li>

            </ul>

          </div>
        </div>

        <!-- USER TYPE -->
        <div class="bbm-field bbm-field-wide">

          <label for="mobile-user-type-filter">
            {{ "Filter by type" | transloco }}
          </label>

          <select
            id="mobile-user-type-filter"
            class="bbm-control"
            [value]="selectedUserType"
            (change)="filterByUserType($any($event.target).value)"
          >
            <ng-container *ngFor="let type of filteredUserTypes">
              <option [value]="type.value">
                {{ type.label | transloco }}
              </option>
            </ng-container>
          </select>

        </div>

      </div>

      <!-- FILTER ACTIONS -->
      <div class="bbm-actions-grid">

        <button
          type="button"
          class="bbm-action-btn"
          [class.bbm-action-primary]="showSearch"
          (click)="toggleSearch()"
        >
          <i
            class="fa-solid fa-magnifying-glass"
            aria-hidden="true"
          ></i>

          <span>
            {{ "Search" | transloco }}
          </span>
        </button>

        <button
          type="button"
          class="bbm-action-btn bbm-action-success"
          (click)="exportToExcel()"
        >
          <i
            class="fa-solid fa-file-excel"
            aria-hidden="true"
          ></i>

          <span>
            {{ "Export" | transloco }}
          </span>
        </button>

      </div>

      <!-- SEARCH -->
      <div
        class="bbm-collapse-panel"
        *ngIf="showSearch"
      >
        <div class="bbm-search-row">

          <div class="bbm-search-control">
            <i
              class="fa-solid fa-magnifying-glass"
              aria-hidden="true"
            ></i>

            <input
              #searchInput
              type="text"
              class="bbm-control"
              [value]="searchValue"
              (input)="applyFilter($event)"
              [placeholder]="'Search' | transloco"
              [attr.aria-label]="'Search' | transloco"
            >
          </div>

          <button
            type="button"
            *ngIf="searchValue"
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-icon-action
            "
            (click)="clearSearch(searchInput)"
            [attr.aria-label]="'Search' | transloco"
          >
            <i
              class="fa-solid fa-xmark"
              aria-hidden="true"
            ></i>
          </button>

        </div>
      </div>

    </section>

    <!-- USERS LIST -->
    <section
      class="bbm-ticket-list"
      *ngIf="allData.length > 0"
    >
      <article
        class="bbm-ticket"
        *ngFor="let element of allData"
      >

        <!-- USER TOP -->
        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div class="bbm-avatar">
              {{ getAvatarText(element) }}
            </div>

            <div class="bbm-copy">
              <span>
                {{ getUserTypeLabel(element) | transloco }}
              </span>

              <h3>
                {{
                  element.first_name ||
                  ("No name" | transloco)
                }}
              </h3>

              <p>
                <i
                  class="fa-solid fa-user"
                  aria-hidden="true"
                ></i>

                <span>
                  {{
                    element.username ||
                    ("No username" | transloco)
                  }}
                </span>
              </p>
            </div>

          </div>

          <!-- USER MENU -->
          <div
            class="dropdown bbm-ticket-menu"
            *ngIf="canManageUsers"
          >
            <button
              type="button"
              class="bbm-menu-btn dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              [title]="'Actions' | transloco"
              [attr.aria-label]="'Actions' | transloco"
            >
              <i
                class="fa-solid fa-ellipsis-vertical"
                aria-hidden="true"
              ></i>
            </button>

            <ul class="dropdown-menu dropdown-menu-end">

              <li>
                <a
                  class="dropdown-item bbm-dropdown-warning"
                  (click)="edituser(element)"
                >
                  <i
                    class="fa-solid fa-pen-to-square"
                    aria-hidden="true"
                  ></i>

                  <span>
                    {{ "Edit" | transloco }}
                  </span>
                </a>
              </li>

              <li>
                <a
                  class="dropdown-item"
                  (click)="showpassword(element.read_password)"
                >
                  <i
                    class="fa-solid fa-eye"
                    aria-hidden="true"
                  ></i>

                  <span>
                    {{ "Show Password" | transloco }}
                  </span>
                </a>
              </li>

              <li>
                <hr class="dropdown-divider">
              </li>

              <li>
                <a
                  class="dropdown-item bbm-dropdown-danger"
                  (click)="deleteuser(element.id)"
                >
                  <i
                    class="fa-solid fa-trash"
                    aria-hidden="true"
                  ></i>

                  <span>
                    {{ "Delete" | transloco }}
                  </span>
                </a>
              </li>

            </ul>
          </div>

        </div>

        <!-- USER TYPE -->
        <div class="bbm-badges-row">

          <span
            class="bbm-status-pill"
            [ngClass]="getBadgeClass(element)"
          >
            <i
              class="fa-solid fa-user-shield"
              aria-hidden="true"
            ></i>

            {{ getUserTypeLabel(element) | transloco }}
          </span>

        </div>

        <!-- USER DETAILS -->
        <div
          class="
            bbm-details-grid
            bbm-ticket-section
          "
        >

          <!-- FULL NAME -->
          <div class="bbm-detail-chip">
            <i
              class="fa-solid fa-address-card"
              aria-hidden="true"
            ></i>

            <span>
              {{ "Full Name" | transloco }}
            </span>

            <strong>
              {{ element.first_name || "-" }}
            </strong>
          </div>

          <!-- INVOICE NAME -->
          <div class="bbm-detail-chip">
            <i
              class="fa-solid fa-file-invoice"
              aria-hidden="true"
            ></i>

            <span>
              {{ "Invoice Name" | transloco }}
            </span>

            <strong>
              {{ element.last_name || "-" }}
            </strong>
          </div>

          <!-- PHONE -->
          <div class="bbm-detail-chip bbm-detail-wide">
            <i
              class="fa-solid fa-phone"
              aria-hidden="true"
            ></i>

            <span>
              {{ "phone" | transloco }}
            </span>

            <strong>
              {{
                element.phone ||
                ("No phone" | transloco)
              }}
            </strong>
          </div>

        </div>

        <!-- SOCIAL LINKS -->
        <div class="bbm-ticket-section">

          <div class="bbm-block-head">
            <span>
              <i
                class="fa-solid fa-share-nodes"
                aria-hidden="true"
              ></i>

              {{ "Social Links" | transloco }}
            </span>
          </div>

          <div class="bbm-social-links">

            <!-- INSTAGRAM -->
            <button
              type="button"
              class="bbm-action-btn bbm-action-danger"
              [disabled]="!element.instagram_link"
              (click)="go(element.instagram_link)"
            >
              <i
                class="fa-brands fa-instagram"
                aria-hidden="true"
              ></i>

              <span>
                {{
                  element.instagram_link
                    ? ("instagram" | transloco)
                    : ("not specific" | transloco)
                }}
              </span>
            </button>

            <!-- TIKTOK -->
            <button
              type="button"
              class="bbm-action-btn"
              [disabled]="!element.tiktok_link"
              (click)="go(element.tiktok_link)"
            >
              <i
                class="fa-brands fa-tiktok"
                aria-hidden="true"
              ></i>

              <span>
                {{
                  element.tiktok_link
                    ? ("tiktok" | transloco)
                    : ("not specific" | transloco)
                }}
              </span>
            </button>

            <!-- FACEBOOK -->
            <button
              type="button"
              class="bbm-action-btn bbm-action-primary"
              [disabled]="!element.facebook_link"
              (click)="go(element.facebook_link)"
            >
              <i
                class="fa-brands fa-facebook"
                aria-hidden="true"
              ></i>

              <span>
                {{
                  element.facebook_link
                    ? ("facebook" | transloco)
                    : ("not specific" | transloco)
                }}
              </span>
            </button>

          </div>

        </div>

      </article>
    </section>

    <!-- LOADING MORE -->
    <div
      class="bbm-loader"
      *ngIf="isLoadingMore"
    >
      <span
        class="bbm-loader-spinner"
        aria-hidden="true"
      ></span>

      <span>
        {{ "Loading more" | transloco }}
      </span>
    </div>

    <!-- END STATE -->
    <div
      class="bbm-end-state"
      *ngIf="
        !isLoadingMore &&
        allData.length > 0 &&
        !hasMore()
      "
    >
      {{ "No more users" | transloco }}
    </div>

    <!-- NO DATA -->
    <div
      class="bbm-empty-state"
      *ngIf="noData && !contentReady"
    >
      <app-nodata></app-nodata>
    </div>

    <!-- HIDDEN TABLE FOR EXCEL EXPORT -->
    <table
      id="userstable-mobile"
      class="bbm-export-table"
    >
      <thead>
        <tr>
          <th>{{ "username" | transloco }}</th>
          <th>{{ "Full Name" | transloco }}</th>
          <th>{{ "Invoice Name" | transloco }}</th>
          <th>{{ "phone" | transloco }}</th>
          <th>{{ "account type" | transloco }}</th>
          <th>{{ "instagram" | transloco }}</th>
          <th>{{ "tiktok" | transloco }}</th>
          <th>{{ "facebook" | transloco }}</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let element of allData">
          <td>{{ element.username }}</td>
          <td>{{ element.first_name }}</td>
          <td>{{ element.last_name }}</td>
          <td>{{ element.phone }}</td>
          <td>
            {{ getUserTypeLabel(element) | transloco }}
          </td>
          <td>{{ element.instagram_link || "-" }}</td>
          <td>{{ element.tiktok_link || "-" }}</td>
          <td>{{ element.facebook_link || "-" }}</td>
        </tr>
      </tbody>
    </table>

  </div>
</div>